module.exports = __webpack_public_path__ + "static/media/gif erro.2db0c82e.gif";